import MaterialReactTable from "material-react-table";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState  } from "react";
import { fetchAnnee,anneeDeleted } from "../../../Redux/anneeReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-multi-lang'
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import SweetAlert from "react-bootstrap-sweetalert";
import { toast, ToastContainer } from "react-toastify";

// core components
function ListAnnee({client}) {
  let lang = window.localStorage.getItem("lang");
  const t = useTranslation();
  document.title = t("Annee.list");
  const dispatch = useDispatch();
  const navigate = useHistory();
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = useState(true);
  const [alert, setAlert] = useState(null);
  function ajouter() {
    navigate.push(client+'/ajouterAnnee');
  }

  const notify = (type, msg) => {
    if (type === 1)
      toast.success(
        <strong>

          {msg}
        </strong>
      );
    else
      toast.error(
        <strong>

          {msg}
        </strong>
      );
  };

  const deleteCmdA = useCallback(
    async (id) => {
      dispatch(
        anneeDeleted(id)
      ).then(e => {
        hideAlert()
        getAnnee()
        notify(1, t("supprimer_succes"));
      })
    },
    [dispatch]
  );

  const confirmMessageDelete = (id, nb) => {
    setAlert(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={t("Annee.supprimer")}
        onConfirm={() => deleteCmdA(id)}
        onCancel={() => hideAlert()}
        confirmBtnBsStyle="info"
        cancelBtnBsStyle="danger"
        confirmBtnText="Oui"
        cancelBtnText="Non"
        showCancel
      >
      </SweetAlert>
    );
  };

  const hideAlert = () => {
    setAlert(null);
  };

  const [columns] = React.useState(
    [
      {
        header: t("year"),
        accessorKey: "annee",
      },
      {
        header: t("actions"),
        accessorKey: "id",
        Cell: ({ cell }) => (
          <div className="actions-right block_action">
            <Button
              onClick={() => {
                navigate.push(client+"/annee/update/" + cell.row.original.id);
              }}
              variant="warning"
              size="sm"
              className="text-warning btn-link edit"
            >
              <i className="fa fa-edit" />
            </Button>
            <Button
            id={"idLigne_" + cell.row.id}
            onClick={(e) => {
              confirmMessageDelete(cell.row.original.id);
            }}
            variant="danger"
            size="sm"
            className="text-danger btn-link delete"
          >
            <i className="fa fa-trash" />
          </Button>
          </div>
        ),
      },
    ]
  );

  function ListTable({ list,loader }) {
    return (
      <MaterialReactTable
      state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}

                          
        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"     
        
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}        
        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }

  const getAnnee = useCallback(async (titre) => {
    var annee = await dispatch(fetchAnnee());
    setEntities(annee.payload);
    setLoader(false)
  }, [dispatch]);
  useEffect(() => {
    getAnnee()
  }, [getAnnee]) //now shut up eslint
  return (
    <>
      <Container fluid>
      <ToastContainer />
      {alert}
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-info mr-1 float-left"
              type="button"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              {t("Annee.add")}
            </Button>
          </Col>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4"> {t("Annee.list")}</Card.Title>
              </Card.Header>
              <Card.Body className="padding-0">
                <ListTable list={entities} loader={loader}></ListTable>
               
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListAnnee;
